export type MatrixPromptPreset = {
  id: string;
  label: string;
  // `{subject}` is replaced with a mention of the matrix's first input column.
  template: string;
};

const FALLBACK_SUBJECT = "this company";

export const MATRIX_PROMPT_PRESETS: MatrixPromptPreset[] = [
  {
    id: "number-of-stores",
    label: "Number of stores",
    template:
      "For {subject}, report how many retail stores, branches, or comparable physical locations it operates, using the latest figures from official filings, investor materials, or press releases. Answer with a number or range, or state that no reliable count was found.",
  },
  {
    id: "headquarters",
    label: "Headquarters",
    template:
      "For {subject}, identify its primary headquarters location: city, region or state if applicable, and country. Prefer official company sources or regulatory filings.",
  },
  {
    id: "major-products",
    label: "Major products",
    template:
      "For {subject}, summarize its major products, services, or flagship offerings as described in public sources (website, annual reports, or major press). Keep the answer concise and factual.",
  },
];

export function matrixPresetPrompt(
  preset: MatrixPromptPreset,
  subject: string | null,
): string {
  return preset.template.replaceAll("{subject}", subject ?? FALLBACK_SUBJECT);
}

export function matrixPromptPresetIdForPrompt(
  promptText: string | undefined,
  subject: string | null,
): string {
  const trimmed = promptText ?? "";
  const match = MATRIX_PROMPT_PRESETS.find(
    (preset) => matrixPresetPrompt(preset, subject) === trimmed,
  );
  return match?.id ?? "custom";
}
